import React from "react";
import styled from "styled-components";
import DarkestTDVideo from '../../assets/SplashScreen.mp4';

const SplashRoot = styled.div`
    padding-top: 5vh;
    position: relative;
    @media (max-width: 768px) {
        display: none;
    }
`;


const VideoSplashCreen = styled.video`
    width: 100%;
    height: 95vh;
    object-fit: contain;
    z-index: 0;
`;

const SplashScreen = () => {
    return (
        <SplashRoot id="splashScreen">
            <VideoSplashCreen autoPlay loop muted>
                <source src={DarkestTDVideo} type="video/mp4" />
            </VideoSplashCreen>
        </SplashRoot>
    )
};
export default SplashScreen;


// WEBPACK FOOTER //
// ./src/pages/SplashScreen/SplashScreen.jsx